import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
const handleNoContentResponse = async (response) => {
    await response.text();
    return null;
};
const lessonCompletionApiSlice = createApi({
    reducerPath: 'lessonCompletionApiSlice',
    baseQuery: fetchBaseQuery({
        baseUrl: '/api',
        prepareHeaders: (headers) => {
            headers.set('Accept', 'application/json');
            return headers;
        },
    }),
    tagTypes: ['Templates'],
    endpoints: (builder) => ({
        getTemplates: builder.query({
            query: (courseId) => ({
                url: '/CourseCustomizationTemplate/GetByCourseId',
                method: 'GET',
                params: { courseId },
            }),
            providesTags: (_result, _error, courseId) => [
                { type: 'Templates', id: courseId },
            ],
        }),
        deleteTemplate: builder.mutation({
            query: (id) => ({
                url: `/CourseCustomizationTemplate/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Templates'],
        }),
        createTemplate: builder.mutation({
            query: ({ body }) => ({
                url: '/CourseCustomizationTemplate',
                method: 'POST',
                body,
            }),
            invalidatesTags: (_result, _error, { courseId }) => [
                { type: 'Templates', id: courseId },
            ],
        }),
        getCourseOutline: builder.query({
            query: (idSection) => ({
                url: '/lessoncompletion/GetCourseOutline',
                params: { idSection },
            }),
        }),
        getCourseOutlineForStudent: builder.query({
            query: ({ idSection, idWebuser }) => ({
                url: '/lessoncompletion/GetCourseOutlineForStudent',
                params: { idSection, idWebuser },
            }),
        }),
        validateSkipLessons: builder.mutation({
            query: ({ idSection, body }) => ({
                url: '/lessoncompletion/Validate',
                method: 'POST',
                params: { idSection },
                body,
            }),
        }),
        editTemplate: builder.mutation({
            query: (template) => ({
                url: '/CourseCustomizationTemplate/UpdateCourseCustomizationTemplate',
                method: 'PUT',
                body: template,
            }),
            invalidatesTags: ['Templates'],
        }),
        skipLessons: builder.mutation({
            query: ({ idSection, body }) => ({
                url: '/lessoncompletion/skipLessons',
                method: 'POST',
                params: { idSection },
                body,
            }),
        }),
        updateTemplateSelection: builder.mutation({
            query: (templateSelection) => ({
                url: '/CourseCustomizationTemplate/UpdateCourseCustomizationTemplateSelection',
                method: 'PUT',
                body: templateSelection,
                responseHandler: handleNoContentResponse,
            }),
            transformResponse: () => undefined,
            invalidatesTags: ['Templates'],
        }),
    }),
});
export const { useCreateTemplateMutation, useDeleteTemplateMutation, useGetTemplatesQuery, useGetCourseOutlineQuery, useGetCourseOutlineForStudentQuery, useValidateSkipLessonsMutation, useEditTemplateMutation, useSkipLessonsMutation, useUpdateTemplateSelectionMutation, } = lessonCompletionApiSlice;
export default lessonCompletionApiSlice;
